import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-635732ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table table-striped table-hover" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "l.p.", -1))
const _hoisted_3 = { class: "right" }
const _hoisted_4 = {
  key: 0,
  class: "fa-solid fa-arrow-down-9-1"
}
const _hoisted_5 = {
  key: 1,
  class: "fa-solid fa-arrow-up-1-9"
}
const _hoisted_6 = {
  key: 2,
  class: "fa-solid fa-arrow-down-wide-short"
}
const _hoisted_7 = { class: "left" }
const _hoisted_8 = {
  key: 0,
  class: "fa-solid fa-arrow-down-z-a"
}
const _hoisted_9 = {
  key: 1,
  class: "fa-solid fa-arrow-up-a-z"
}
const _hoisted_10 = {
  key: 2,
  class: "fa-solid fa-arrow-down-wide-short"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "left" }, "voivodship", -1))
const _hoisted_12 = { class: "right" }
const _hoisted_13 = {
  key: 0,
  class: "fa-solid fa-arrow-down-9-1"
}
const _hoisted_14 = {
  key: 1,
  class: "fa-solid fa-arrow-up-1-9"
}
const _hoisted_15 = {
  key: 2,
  class: "fa-solid fa-arrow-down-wide-short"
}
const _hoisted_16 = { class: "right" }
const _hoisted_17 = {
  key: 0,
  class: "fa-solid fa-arrow-down-9-1"
}
const _hoisted_18 = {
  key: 1,
  class: "fa-solid fa-arrow-up-1-9"
}
const _hoisted_19 = {
  key: 2,
  class: "fa-solid fa-arrow-down-wide-short"
}
const _hoisted_20 = { class: "right" }
const _hoisted_21 = { class: "left" }
const _hoisted_22 = { class: "left" }
const _hoisted_23 = { class: "right" }
const _hoisted_24 = { class: "right" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("Sorry! No more cities found. "),
    /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-face-frown" })
  ])
], -1))
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _hoisted_2,
        _createElementVNode("th", _hoisted_3, [
          _createTextVNode(" id "),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.sortBy('id')), ["prevent"])),
            class: _normalizeClass(_ctx.sortParams.orderBy === 'id' ? 'active' : '')
          }, [
            (_ctx.sortParams.orderBy === 'id' && _ctx.sortParams.order)
              ? (_openBlock(), _createElementBlock("i", _hoisted_4))
              : (_ctx.sortParams.orderBy === 'id' && !_ctx.sortParams.order)
                ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                : (_openBlock(), _createElementBlock("i", _hoisted_6))
          ], 2)
        ]),
        _createElementVNode("th", _hoisted_7, [
          _createTextVNode(" name "),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.sortBy('name')), ["prevent"])),
            class: _normalizeClass(_ctx.sortParams.orderBy === 'name' ? 'active' : '')
          }, [
            (_ctx.sortParams.orderBy === 'name' && _ctx.sortParams.order)
              ? (_openBlock(), _createElementBlock("i", _hoisted_8))
              : (_ctx.sortParams.orderBy === 'name' && !_ctx.sortParams.order)
                ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                : (_openBlock(), _createElementBlock("i", _hoisted_10))
          ], 2)
        ]),
        _hoisted_11,
        _createElementVNode("th", _hoisted_12, [
          _createTextVNode(" population "),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.sortBy('population')), ["prevent"])),
            class: _normalizeClass(_ctx.sortParams.orderBy === 'population' ? 'active' : '')
          }, [
            (_ctx.sortParams.orderBy === 'population' && _ctx.sortParams.order)
              ? (_openBlock(), _createElementBlock("i", _hoisted_13))
              : (_ctx.sortParams.orderBy === 'population' && !_ctx.sortParams.order)
                ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                : (_openBlock(), _createElementBlock("i", _hoisted_15))
          ], 2)
        ]),
        _createElementVNode("th", _hoisted_16, [
          _createTextVNode(" area "),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.sortBy('area')), ["prevent"])),
            class: _normalizeClass(_ctx.sortParams.orderBy === 'area' ? 'active' : '')
          }, [
            (_ctx.sortParams.orderBy === 'area' && _ctx.sortParams.order)
              ? (_openBlock(), _createElementBlock("i", _hoisted_17))
              : (_ctx.sortParams.orderBy === 'area' && !_ctx.sortParams.order)
                ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                : (_openBlock(), _createElementBlock("i", _hoisted_19))
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, (city, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: city }, [
          _createElementVNode("th", null, _toDisplayString(index + 1), 1),
          _createElementVNode("td", _hoisted_20, _toDisplayString(city.id), 1),
          _createElementVNode("td", _hoisted_21, _toDisplayString(city.name), 1),
          _createElementVNode("td", _hoisted_22, _toDisplayString(city.voivodship), 1),
          _createElementVNode("td", _hoisted_23, _toDisplayString(city.population.toLocaleString().replaceAll(',', ' ')), 1),
          _createElementVNode("td", _hoisted_24, [
            _createTextVNode(_toDisplayString(parseFloat(city.area).toFixed(2)) + " km", 1),
            _hoisted_25
          ])
        ]))
      }), 128)),
      (_ctx.cities.length === 0)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_26, _hoisted_28))
        : _createCommentVNode("", true)
    ])
  ]))
}